import { render } from "./premium.vue?vue&type=template&id=9af2e848&scoped=true"
import script from "./premium.vue?vue&type=script&lang=js"
export * from "./premium.vue?vue&type=script&lang=js"

import "./premium.vue?vue&type=style&index=0&id=9af2e848&scoped=true&lang=css"
import "./premium.vue?vue&type=style&index=1&id=9af2e848&lang=css"
script.render = render
script.__scopeId = "data-v-9af2e848"

export default script